import LocalStorageUtils from '@/utils/LocalStorageUtils.js';

export function usePreferences() {
  const fetchPreferences = () => {
    return LocalStorageUtils.getReadyChek();
  };

  const savePreferences = (preferences) => {
    LocalStorageUtils.setReadyChek(preferences);
  };

  const fetchPreferencesPage = (preferences, pageName = "all") => {
    let pages = preferences["pages"];
    if (pages == null) {
      pages = {};
      preferences["pages"] = pages;
    }
    let page = pages[pageName];
    if (page == null) {
      page = {};
      pages[pageName] = page;
    }
    if (typeof page == "string") {
      let pageSize = page;
      page = {};
      page["pageSize"] = pageSize;
      pages[pageName] = page;
    }
    return page;
  };

  const pageSize = (query, pageName = "all") => {
    const preferences = fetchPreferences();
    const page = fetchPreferencesPage(preferences, pageName);
    const defaultValue = "10";
    let value = page["size"];
    if (value == null) {
      value = defaultValue;
    }
    return query["pageSize"] ? query["pageSize"] : value;
  };

  const pageFilter = (query, field, defaultValue, pageName = "all") => {
    const preferences = fetchPreferences();
    const page = fetchPreferencesPage(preferences, pageName);
    let value = page[field];
    if (value == null) {
      value = defaultValue;
    }
    return query[field] ? query[field] : value;
  };

  const pageSortBy = (query, sortByDefaultValue, pageName = "all") => {
    const preferences = fetchPreferences();
    const page = fetchPreferencesPage(preferences, pageName);
    let value = page["sortBy"];
    if (value == null || value == undefined) {
      value = sortByDefaultValue;
    }
    return query["sortBy"] ? query["sortBy"] : value;
  };

  /** A setting remembered for one page, such as whether a panel is open; defaultValue when unset. */
  const pagePreference = (field, defaultValue, pageName = "all") => {
    const page = fetchPreferencesPage(fetchPreferences(), pageName);
    const value = page[field];
    return value == null ? defaultValue : value;
  };

  const savePagePreference = (field, value, pageName = "all") => {
    const preferences = fetchPreferences();
    const page = fetchPreferencesPage(preferences, pageName);
    page[field] = value;
    savePreferences(preferences);
  };

  const pageNumberForFilter = (query) => {
    return query["page"] ? (query["page"] - 1) : 0;
  };

  return {
    fetchPreferences: fetchPreferences,
    savePreferences: savePreferences,
    fetchPreferencesPage: fetchPreferencesPage,
    pageSize: pageSize,
    pageFilter: pageFilter,
    pageSortBy: pageSortBy,
    pageNumberForFilter: pageNumberForFilter,
    pagePreference: pagePreference,
    savePagePreference: savePagePreference,
  };
}